/**
 * @desc 个人任务查询
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.PersonalTaskRequest,
): Promise<defs.StandardReturn<defs.QueryPersonaTaskListResponse>> {
  return defHttp.post({
    url: '/web/personal/search',
    data,
  });
}

export function mock(
  data: defs.PersonalTaskRequest,
): Promise<defs.StandardReturn<defs.QueryPersonaTaskListResponse>> {
  return defHttp.post({
    url: '/mock/web/personal/search',
    data,
  });
}
